enum FilterType {
  STATUS = 'STATUS',
  FLOW_TYPE = 'FLOW_TYPE',
}
export default FilterType;
